/**
 * Authenticated fetch wrapper.
 *
 * Drop-in replacement for `fetch('/api/...')` that adds the
 * Authorization header from localStorage. Use this instead of
 * raw fetch() for ALL /api/ calls.
 *
 * Usage:
 *   import { authFetch } from '../services/authFetch';
 *   const response = await authFetch(`/api/micro-learning/modules?${params}`);
 */

export async function authFetch(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const token = localStorage.getItem('access_token');
  const headers = new Headers(options.headers || {});

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  if (!headers.has('Content-Type') && options.body) {
    headers.set('Content-Type', 'application/json');
  }

  return fetch(url, { ...options, headers });
}
